import React from "react";
import  { useState, useEffect } from 'react';
import './classes/CricketEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const CricketEducationProgarm = () => {

    // const navigate = useNavigate();
   const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Ken Jacobs",
                image: "/basic/web/images/scout/kenJacobs.jpg",
             },
             
            
        ];
        setMentors(mentors);

        const courseTopics = [
            "Recruiting, player evaluation, player ratings and in-depth player analysis",
            "Club Scouting",
            "Domestic Scouting",
            "International Scouting",
            "Methods of ranking prospects",
            "The making of a proper cricket scouting report",
            "The language and history of cricket as it pertains to different parts of the world",
            "Concise evaluation techniques and terminology",
            "New age scouting vs. Traditional methods",
            ];
        setCourseTopics(courseTopics);


    },[]);

    useEffect(() => {
        Promise.all([
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
   
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="cricket-education-progarm-main">
                <Helmet><title>Cricket Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="cricket-education-progarm-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW Cricket Education Program</h1>
                            <p>SMWW Cricket Scouts have been trained and mentored by some of the best in the industry. SMWW Cricket Scouts have completed a rigorous eight week training program and instructed by Ken Jacobs, former Victoria Cricket CEO. SMWW Cricket Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the school, club or international level.</p>
                            <h2>SMWW Cricket Scouting Mentors:</h2>
                             {mentors.map((mentor,index) => (
                                <div className="scout-mentors" key={mentor.name} style={{ marginBottom: "1.5rem", overflow: "auto" }}>
                                <img
                                    src={mentor.image}
                                    alt={mentor.name}
                                    className={`mentor-image mentor-image-${index}`}
                                />
                                <p>
                                    SMWW Cricket Scouts have been mentored by <strong>{mentor.name}</strong> 
                                    <p>From 1980-2007 Ken was CEO of Cricket Victoria, in Melbourne Australia. Cricket Victoria is the largest participant State in Australian cricket with more clubs and, more people playing the game than in any other State of Australia. During this period Ken oversaw a growth in revenue from $500k to $25 million (Australian) and was also responsible for the development and implementation of Cricket Victoria's first Strategic Plan and an increase in participation levels to a record 185,000 regular participants. Cricket Victoria is also responsible for the staging of international cricket matches in Melbourne at the world famous Melbourne Cricket Ground (MCG) on behalf of Cricket Australia and during his period as CEO Ken was involved in the management and delivery of many international matches involving all of the major Test match playing countries - this included the iconic Boxing Day Test matches played at the venue each, the 1992 World Cup; and a host of one day international matches played at the venue.</p>
                                    <p>From February-May 2007 Ken was engaged by the International Cricket Council as Event Manger for the staging of the ICC 2007 World Cup in the Caribbean region.</p>
                                    <p>Ken now manages his own consultancy business and has recently been engaged in the development of a strategic plan for a significant state sporting body; project work to investigate a national sponsorship agreement and equipment review to benefit cricket clubs and Associations throughout Australia; consulting work for one of Australia's leading national sports travel companies and is currently involved in the development and implementation of an event plan including a comprehensive risk management assessment and commercial operations plan) for a new corporate Twenty20 cricket competition in Melbourne.</p>
                                </p>
                                </div>
                            ))}
                            <h2>SMWW Cricket Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <a className="reddbtnn" href={`https://${configData.RSMWW_DOMAIN}/application`}>
                                Apply today for training as an SMWW Certified Cricket Scout
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                            <span><strong><a href="/scout-sports/cricket">Click here</a>   to search for a SMWW Cricket Scout by Area.   </strong><br/>                            
                            SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span></p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                    </div>
                  
                    </div>
                </div>
                <div className="right">
                      {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                     {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default CricketEducationProgarm;